export default function quickresponses(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                quickresponse: action.quickresponse,
            }
        default:
            return state;
    }
}
